import React from "react";

const SkillSet1 = () => {
    return (
        <div className="skills__content">
            <div className="skills__box">
                <div className="skills__group">

                    <div className="skills__data">
                        <div>
                            <h3 className="skills__name">HTML</h3>
                            <span className="skills__level">&#9679; &#9679; &#9679; &#9679; &#9675;</span>
                        </div>
                    </div>

                    <div className="skills__data">
                        <div>
                            <h3 className="skills__name">CSS</h3>
                            <span className="skills__level">&#9679; &#9679; &#9679; &#9675; &#9675;</span>
                        </div>
                    </div>

                    <div className="skills__data">
                        <div>
                            <h3 className="skills__name">Bootstrap</h3>
                            <span className="skills__level">&#9679; &#9679; &#9679; &#9679; &#9675;</span>
                        </div>
                    </div>

                </div>

                <div className="skills__group">

                    <div className="skills__data">
                        <div>
                            <h3 className="skills__name">JavaScript</h3>
                            <span className="skills__level">&#9679; &#9679; &#9679; &#9679; &#9675;</span>
                        </div>
                    </div>

                    <div className="skills__data">
                        <div>
                            <h3 className="skills__name">Git & GitHub</h3>
                            <span className="skills__level">&#9679; &#9679; &#9679; &#9675; &#9675;</span>
                        </div>
                    </div>

                    <div className="skills__data">
                        <div>
                            <h3 className="skills__name">React</h3>
                            <span className="skills__level">&#9679; &#9679; &#9679; &#9675; &#9675;</span>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    );
}

export default SkillSet1;